import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoadingScreen from '../ui/LoadingScreen';

/**
 * Protege un árbol de rutas: exige sesión iniciada. Si aún estamos
 * comprobando el localStorage, muestra una pantalla de carga en vez de
 * redirigir de una vez (evita un "parpadeo" al login).
 */
export default function ProtectedRoute() {
  const { isAuthenticated, initializing } = useAuth();
  const location = useLocation();

  if (initializing) {
    return <LoadingScreen label="Cargando Pulso17…" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
